export default __webpack_public_path__ + "static/6652-017d2126c47cf364641c9916c1e16369.jpg";